import { ListItemIcon, ListItemText, Menu, Stack, Typography } from '@mui/material';
import { ListItem, ListItemButton } from 'src/components/Drawer/SidebarStyled';
import { IMenuItem } from 'src/components/Drawer/SidebarMenu';
import { useNavigate } from 'react-router-dom';

interface IDropdownMenuProps {
  anchorEl: null | HTMLElement;
  handleMenuClose: () => void;
  menuData: IMenuItem[];
}

const DropdownMenu = (props: IDropdownMenuProps) => {
  const { anchorEl, handleMenuClose, menuData } = props;
  const navigate = useNavigate();

  // const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };
  //
  // const handleMenuClose = () => {
  //   setAnchorEl(null);
  // };

  return (
    <Menu
      sx={{ mt: '45px' }}
      id="menu-header"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
    >
      <Stack pt={1} pl={1} pr={1} flexDirection={'column'} gap={1}>
        {menuData.map((menuItem) => {
          return (
            <ListItem sx={{ mx: 0 }} key={menuItem.key} disablePadding={true}>
              <ListItemButton
                disabled={menuItem.disabled}
                sx={{
                  px: 2,
                  py: 1,
                  ':hover': {
                    '& .MuiSvgIcon-root path': {
                      fill: 'none',
                    },
                    '& .MuiTypography-root': {
                      color: 'inherit',
                    },
                  },
                }}
                onClick={() => {
                  if (menuItem.onClickFn) {
                    return menuItem.onClickFn();
                  }
                  if (!menuItem.path) return;
                  return navigate(menuItem.path);
                }}
              >
                <ListItemIcon sx={{ color: 'inherit', minWidth: 'fit-content', mr: 1 }}>{menuItem.icon}</ListItemIcon>
                <ListItemText sx={{ pl: 1 }} primary={<Typography variant="subtitle2">{menuItem.text}</Typography>} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </Stack>
    </Menu>
  );
};

export default DropdownMenu;
